var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',{class:_vm.buttonClass,attrs:{"type":"submit","variant":"confirm","block":"","loading":_vm.loading,"data-testid":"new-user-register-button","data-track-action":"register","data-track-label":_vm.trackLabel}},[_vm._v("\n  "+_vm._s(_vm.buttonText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }